import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  CANCEL_RECURRING_SERIES_REQUEST,
  CANCEL_RECURRING_SERIES_SUCCESS,
  CANCEL_RECURRING_SERIES_FAILURE,
} = TherapistAction;

function* cancelRecurringSeries(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.cancelRecurringSeries,
      {
        recurringAppointmentUuid: action.payload.recurringAppointmentUuid,
        startDate: action.payload.startDate,
      }
    );
    if (response?.status === 200 || response?.status === 201) {
      yield put({ type: CANCEL_RECURRING_SERIES_SUCCESS, payload: response.data });
      
      // Call GET_ALL_THERAPIST_TASK_REQUEST after success, similar to therapistPatientUnAssignSaga
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST,
        payload: {
          data: {
            providerId: action.payload.providerId,
            localDate: action.payload?.currentDate,
            type: action.payload.type,
            active: true,
            discipline: action.payload.discipline,
            skill: action.payload.skill,
            isV2: action.payload?.isV2,
          },
          pageNo: action.payload.meta?.taskPage || 0,
          pageSize: 20,
        },
      });
      yield put({
        type: TherapistAction.DISABLE_AUTO_MATCH_REQUEST,
        payload: {
          providerId: action.payload.providerId,
          discipline: action.payload.discipline,
          currentDate: action.payload?.currentDate,
        },
      });
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST,
        payload: {
          providerId: action.payload.providerId,
          localDate: action.payload?.currentDate,
          data: { isV2: action.payload?.isV2 },
        },
      });
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
        payload: {
          pageSize: 20,
          pageNo: action.payload.meta?.therapistPage || 0,
          data: {
            providerId: action.payload.providerId,
            localDate: action.payload?.currentDate,
            discipline: action.payload.discipline,
            sortBy: action.payload.sortBy || '',
            searchData: action.payload?.searchData || '',
            filterByUuid: action.payload?.filterByUuid || null,
          },
        },
      });
    } else {
      console.error('Unexpected response status:', response?.status);
      throw response.data;
    }
  } catch (error) {
    console.error('Cancel Recurring Series Error:', error);
    yield put({ type: CANCEL_RECURRING_SERIES_FAILURE, payload: error });
  }
}

function* cancelRecurringSeriesSaga() {
  yield takeEvery(CANCEL_RECURRING_SERIES_REQUEST, cancelRecurringSeries);
}

export default cancelRecurringSeriesSaga;
